import script from "./SubContractorOnboardingView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubContractorOnboardingView.vue?vue&type=script&setup=true&lang=js"

import "./SubContractorOnboardingView.vue?vue&type=style&index=0&id=a5dd45be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5dd45be"]])

export default __exports__